import { init, FullStory } from '@fullstory/browser';

let hasStarted = false;

const isDevEnvironment = process.env.GATSBY_SITE_ENV === 'development' || process.env.GATSBY_SITE_ENV === 'dev';

/**
 * Safe FullStory wrapper that no-ops in development environments
 * and gracefully handles cases where FullStory is not initialized.
 * Use this instead of importing FullStory directly from '@fullstory/browser'.
 */
export const safeFullStory = (...args) => {
    if (isDevEnvironment || typeof window === 'undefined') {
        return;
    }
    try {
        return FullStory(...args);
    } catch (error) {
        console.warn('FullStory call skipped:', error.message);
    }
};

/**
 * Initialize FullStory with manual delay.
 * Sets _fs_capture_on_startup to false and starts capture on first user interaction.
 */
export const initFullStory = () => {
    if (typeof window === 'undefined' || isDevEnvironment) {
        return;
    }

    try {
        // Initialize FullStory with your org ID
        init({
            orgId: process.env.GATSBY_FULLSTORY_ORG_ID,
            devMode: isDevEnvironment,
        });

        // Shutdown to prevent automatic capture on startup
        FullStory('shutdown');
    } catch (error) {
        console.error('FullStory initialization failed:', error);
        return;
    }

    const startCaptureOnInteraction = () => {
        if (hasStarted) return;

        hasStarted = true;
        try {
            // Start FullStory capture
            FullStory('restart'); // Restart to capture from this point
        } catch (error) {
            console.error('FullStory restart failed:', error);
        }
    };

    // Listen for first interaction event to start capture (supports both desktop and mobile)
    document.addEventListener('click', startCaptureOnInteraction, { capture: true, once: true });
    document.addEventListener('touchstart', startCaptureOnInteraction, { capture: true, once: true });
    document.addEventListener('touchend', startCaptureOnInteraction, { capture: true, once: true });
};
